<template>
  <span
    v-if="startTime && endTime"
    class="work-time-label"
    :class="{'is-working-time': isWorkingTime}"
  >
    <font-awesome-icon class="work-time-label__icon" icon="clock"/>
    {{ startTime }} - {{ endTime }}
  </span>
</template>

<script>
  import { DateTime } from 'luxon'

  export default {
    name: 'WorkTimeLabel',
    props: {
      startTime: {
        type: String,
        default: null,
      },
      endTime: {
        type: String,
        default: null,
      },
      timeZone: {
        type: String,
        default: null,
      },
    },
    computed: {
      isWorkingTime () {
        if (this.startTime && this.endTime && this.timeZone) {
          const openTime = DateTime.fromFormat(this.startTime, 'HH:mm', { zone: this.timeZone })
          const closeTime = DateTime.fromFormat(this.endTime, 'HH:mm', { zone: this.timeZone })
          const filialTime = DateTime.now().setZone(this.timeZone)
          /* console.log({
            openTime,
            closeTime,
            filialTime,
            res: filialTime.toMillis() >= openTime.toMillis() && filialTime.toMillis() < closeTime.toMillis(),
          }) */
          return filialTime.toMillis() >= openTime.toMillis() && filialTime.toMillis() < closeTime.toMillis()
        }
        return true
      },
    },
  }
</script>

<style scoped lang="less">
.work-time-label {
  //display: block;
  //font-size: 14px;
  //line-height: 14px;
  transition: color 0.2s ease;

  &__icon {
    color: @color-error;
    margin-right: 5px;
    //font-size: 16px;
    //line-height: 21px;
  }

  &.is-working-time {
    .work-time-label__icon {
      color: @color-success;
    }
  }
}

</style>
